import { Injectable } from '@angular/core';
import { LoadingBarComponent } from './loading-bar.component';


@Injectable({
    providedIn: 'root',
})
export class LoadingBarService {

    comp?: LoadingBarComponent;

    register(comp: LoadingBarComponent) {
        this.comp = comp;
    }

    unregister(comp: LoadingBarComponent) {
        if (this.comp === comp) {
            this.comp = undefined;
        }
    }
}
